import { STORAGE_KEYS } from '../../constants/api';

export interface TokenData {
  accessToken: string;
  refreshToken?: string;
  expiresAt?: number;
}

class TokenManager {
  getAccessToken(): string | null {
    return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
  }

  setTokens(tokenData: TokenData): void {
    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, tokenData.accessToken);

    if (tokenData.refreshToken) {
      localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, tokenData.refreshToken);
    }

    if (tokenData.expiresAt) {
      localStorage.setItem(STORAGE_KEYS.TOKEN_EXPIRES_AT, tokenData.expiresAt.toString());
    }
  }

  clearTokens(): void {
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.TOKEN_EXPIRES_AT);
    localStorage.removeItem(STORAGE_KEYS.USER_DATA);
  }

  isTokenExpired(): boolean {
    const expiresAt = localStorage.getItem(STORAGE_KEYS.TOKEN_EXPIRES_AT);
    if (!expiresAt) return false;
    
    return Date.now() > parseInt(expiresAt);
  }

  hasValidTokens(): boolean {
    const accessToken = this.getAccessToken();
    const refreshToken = this.getRefreshToken();
    return !!(accessToken && refreshToken && !this.isTokenExpired());
  }
}

export const tokenManager = new TokenManager();
